
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import { PuntosPeligroState } from '@/store/modules/puntos-peligro/types'
import addDays from 'date-fns/esm/addDays'
import format from 'date-fns/esm/format'
import parse from 'date-fns/esm/parse'
import { GoogleMapMarker, InfoView } from '@/store/modules/google-maps/types'
import { PronosticoHidricoEstacionApi } from '@/domain/entities/Api'
import DesktopFooter from '@/components/DesktopFooter.vue'
import { getEnvironments } from '@/environments'

const env = getEnvironments() || {}
const MODULE_PUNTO_PELIGRO = 'puntosPeligro'
const MODULE_ESTACION = 'pronosticoHidricoEstacion'
const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    DesktopFooter
  }
})
export default class PuntosPeligro extends Vue {
  @State(MODULE_PUNTO_PELIGRO)
  public puntosPeligro!: PuntosPeligroState;
  @Action('getPuntosPeligro', { namespace: MODULE_PUNTO_PELIGRO })
  private getPuntosPeligro: any
  @Getter('defaultMarker', { namespace: MODULE_PUNTO_PELIGRO })
  private defaultMarker?: string

  @Action('setMarkers', { namespace: GOOGLE_MAPS_MODULE })
  private setMarkers: any
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any
  @Action('setInfoViewData', { namespace: GOOGLE_MAPS_MODULE })
  private setInfoViewData: any
  @Action('resetInfoView', { namespace: GOOGLE_MAPS_MODULE })
  private resetInfoView: any
  @Action('setOpenDefaultMarkerOption', { namespace: GOOGLE_MAPS_MODULE })
  private setOpenDefaultMarkerOption: any
  @Action('setDefaultMarker', { namespace: GOOGLE_MAPS_MODULE })
  private setDefaultMarker: any
  @Getter('infoView', { namespace: GOOGLE_MAPS_MODULE })
  private infoView!: InfoView
  @Getter('activeMarker', { namespace: GOOGLE_MAPS_MODULE })
  private activeMarker!: GoogleMapMarker

  formatPuntos (puntosPeligro: PuntosPeligroState) {
    if (puntosPeligro) {
      return puntosPeligro.punto_peligro_list.map((punto) => {
        return {
          id: punto.id,
          position: {
            lat: punto.latitud,
            lng: punto.longitud
          },
          color: punto.hex,
          type: 'circle',
          label: punto.id.toString(),
          icon: '',
          params: punto
        }
      })
    } else {
      return []
    }
  }

  async created () {
    await this.resetInfoView()
    await this.setOpenDefaultMarkerOption(false)
    await this.setOpenDefaultMarkerOption(true)
    await this.getPuntosPeligro()
    this.setDefaultMarker(this.defaultMarker)
    const markers = this.formatPuntos(this.puntosPeligro)
    await this.setMarkers(markers)
    const position = {
      lat: env.settings.PUNTOS_PELIGRO.center.lat,
      lng: env.settings.PUNTOS_PELIGRO.center.lng
    }
    const zoom = env.settings.PUNTOS_PELIGRO.zoom
    this.setPosition({ position, zoom })
  }
  /*
  async setInfoViewLocalData () {
    const periodo = {
      inicio: format(addDays(Date.now(), -6), 'yyyy-MM-dd'),
      fin: format(Date.now(), 'yyyy-MM-dd')
    }
    this.setInfoViewData({
      })
    })
  }
*/
  @Watch('infoView.status.active')
  async infoViewChanged (active: boolean) {
    if (active) {
      const { position, params: { fecha_actualizacion, data_list } } = this.activeMarker
      const [title, subtitle] = fecha_actualizacion.split('<br>')
      const data = data_list ? [{
        datos: [{
          valor_list: data_list.map((label: any) => ({ tipo: label.key, valor: label.val }))
        }]
      }] : null
      // const date = pronostico ? pronostico.fecha : ''
      this.setInfoViewData({
        title,
        link: '',
        subtitle,
        emptyResponse: '',
        data,
        // date,
        position,
        options: {
          pixelOffset: {
            width: 0,
            height: -16
          }
        }
      })
      // this.setInfoViewLocalData()
    }
  }

  async beforeDestroy () {
    await this.resetInfoView()
    await this.setOpenDefaultMarkerOption(false)
    await this.setMarkers([])
  }
}
